// In-app feedback widget — build-time config, parsed from baked env vars.
// All keys are fe-baked (public-by-design widget token, not a secret).
//
// FEEDBACK_WIDGET_TOKEN IS THE SAME VALUE IN .env.staging AND .env.production.
// This is intentional — do NOT "fix" it as a copy-paste error.
//
// Userback's account issues a single GLOBAL access token. Routing a report to the
// Staging project vs the Production project is DOMAIN-BASED: each project carries
// its own domain list in the Userback dashboard, and the widget is attributed by
// the domain it loads on. There is no per-environment token to differ, so the two
// dotenv files necessarily carry identical values. Staging/production separation
// is configured dashboard-side, not here.
export const feedbackConfig = {
  enabled: process.env.FEEDBACK_WIDGET_ENABLED === "true",
  provider: process.env.FEEDBACK_WIDGET_PROVIDER || "",
  token: process.env.FEEDBACK_WIDGET_TOKEN || "",
};

export function isConfigValid() {
  return (
    feedbackConfig.enabled &&
    // v1 ships the Userback adapter only (D7). Widen this list to
    // ["userback", "usersnap", "gleap"] when those adapters are actually written.
    ["userback"].includes(feedbackConfig.provider) &&
    feedbackConfig.token.length > 0
  );
}
